import React, { Component } from "react";
import { Modal, Table, Button, Input, Card, message } from "antd";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import DriversStore from "../store/DriversStore";
import ChatDriverStore from "../store/ChatDriverStore";
import { EyeFilled } from "@ant-design/icons";
import Draggable from "react-draggable";

class ChatDriver extends Component {
    constructor(prop, context) {
        super(prop, context);
        this.state = {
            drivers: [],
            selectedDriver: null,
            chatMessages: [],
            showDriverList: true,
            showChatModal: false,
            msgId: null
        };
        this.driverStore = new DriversStore();
        // this.ChatDriverStore = context.chatDriverStore;

    }

    componentDidMount() {
        this.ChatDriverStore = this.context.chatDriverStore;
        this.getDrivers();
    }

    componentWillUnmount() {
        if (this.state.msgId) {
            clearInterval(this.state.msgId);
        }
    }

    /* ---------------- GET DRIVERS ---------------- */

    getDrivers = async () => {
        var DriverList = await this.ChatDriverStore.getDriverDetails({
            companyId: this.props.getUserData().userCompanyId,
        });
        console.log(
            DriverList
        )
        await this.setState({ driverList: DriverList });
    };
    getAllCompanyMsgs = async () => {
        await this.ChatDriverStore.getMessages({
            companyId: this.props.getUserData().userCompanyId,
            isadmin: this.props.getUserData().isadmin,
            userId: this.props.getUserData().userId
        });
    }
    /* ---------------- OPEN CHAT ---------------- */

    openChat = async (driver) => {
        this.getAllCompanyMsgs()
        this.setState(
            {
                selectedDriver: driver,
                showChatModal: true,
                showDriverList: false
            },
            () => {
                this.getChatDetails(driver.driverId);

                const msgId = setInterval(() => {
                    this.getChatDetails(driver.driverId);
                }, 10000);

                this.setState({ msgId });
            }
        );
    };

    /* ---------------- FETCH MESSAGES ---------------- */

    getChatDetails = async (driverId) => {
        var message = await this.ChatDriverStore.getAllMessages({
            companyId: this.props.getUserData().userCompanyId,
            driverId: driverId
        });
        console.log(" message", message)

        this.setState({ chatMessages: message }, () => {
            this.scrollToBottom();
        });

    };

    /* ---------------- SEND MESSAGE ---------------- */

    sendMessage = async (value) => {
        const { selectedDriver } = this.state;

        if (!value) return;

        var message = await this.ChatDriverStore.sendMessage({
            companyId: this.props.getUserData().userCompanyId,
            driverId: selectedDriver.driverId,
            message: value,
            type: 'in',
            userIdFrom: this.props.getUserData().userId,
            full_imei: selectedDriver.full_imei

        });


        this.getChatDetails(selectedDriver.driverId);
        this.setState({ messageText: "" });
    };

    /* ---------------- SCROLL ---------------- */

    scrollToBottom = () => {
        if (this.chatContainer) {
            this.chatContainer.scrollTop =
                this.chatContainer.scrollHeight;
        }
    };

    /* ---------------- CLOSE CHAT ---------------- */

    closeChat = () => {
        if (this.state.msgId) {
            clearInterval(this.state.msgId);
        }
        this.getAllCompanyMsgs()


        this.setState({
            showChatModal: false,
            selectedDriver: null,
            msgId: null,
            showDriverList: true
        });
    };

    /* ---------------- RENDER ---------------- */

    render() {
        const {
            showDriverList,
            selectedDriver,
        } = this.state;
        const unreadIds =
            this.context.chatDriverStore.driverIdsWithUnread || [];
        return (
            <>
                {/* DRIVER LIST */}
                <Modal
                    title="Driver List"
                    open={showDriverList}
                    onCancel={this.props.onClose}
                    footer={null}
                >
                    <Table
                        rowClassName={(record) =>
                            unreadIds.includes(Number(record.driverId))
                                ? "newMessageClass-row"
                                : ""
                        }
                        columns={[
                            {
                                title: "Driver Name",
                                dataIndex: "driverName",
                                render: (_, record) => (
                                    <>
                                        {record.driverOnlineStatus === 1 ? "🟢" : "🔴"}{" "}
                                        {record.driverName}
                                    </>
                                )
                            },
                            {
                                title: "Taxi No",
                                dataIndex: "vehicleNo"
                            },
                            {
                                title: "Action",
                                align: "center",
                                render: (_, record) => (
                                    <EyeFilled style={{ cursor: "pointer", fontSize: "15px", color: "#645959" }} onClick={() => this.openChat(record)} />

                                )
                            }
                        ]}
                        dataSource={this.state.driverList}
                        rowKey="driverId"
                    />
                </Modal>

                {/* CHAT WINDOW */}
                {this.state.showChatModal &&
                    <Draggable handle=".chat-header">
                        <div className="chat-wrapper">
                            <Card className="chat-card" bodyStyle={{ padding: 0 }}>

                                {/* HEADER */}
                                <div className="chat-header">
                                    <span>
                                        Chat with driver {selectedDriver?.driverName || ""}
                                    </span>

                                    <Button
                                        type="text"
                                        onClick={this.closeChat}
                                        className="chat-close-btn"
                                    >
                                        ✕
                                    </Button>
                                </div>

                                {/* CHAT BODY */}
                                <div
                                    className="chat-body"
                                    ref={(el) => (this.chatContainer = el)}
                                >
                                    {this.state.chatMessages.map((msg, index) => (
                                        <div
                                            key={index}
                                            className={`chat-message ${msg.type === "in" ? "incoming" : "outgoing"
                                                }`}
                                        >
                                            <div className="chat-bubble">
                                                <div className="chat-text">
                                                    {msg.message}
                                                </div>
                                                <div className="chat-time">
                                                    {msg.dateTime}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* INPUT AREA */}
                                <div className="chat-input-area">
                                    <Input
                                        placeholder="Type a message..."
                                        value={this.state.messageText}
                                        onChange={(e) =>
                                            this.setState({ messageText: e.target.value })
                                        }
                                        onPressEnter={() =>
                                            this.sendMessage(this.state.messageText)
                                        }
                                        className="chat-input"
                                    />

                                    <Button
                                        type="primary"
                                        onClick={() =>
                                            this.sendMessage(this.state.messageText)
                                        }
                                        className="chat-send-btn"
                                    >
                                        Send
                                    </Button>
                                </div>
                            </Card>
                        </div>
                    </Draggable>
                }

            </>
        );
    }
}

ChatDriver.contextType = StoreContext;
export default observer(withRouter(ChatDriver));
